import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Inbox } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useProject } from '@/lib/project-context'
import { Button } from '@/components/ui/button'

/**
 * PLAN-084: the inbox routes stay registered (deep links, notifications) but
 * render a "not enabled" page instead of the feature when the organization
 * has the `inbox` flag off. The server refuses the procedures as well.
 */
export function InboxFeatureGate({
  projectId,
  children,
}: {
  projectId: string
  children: ReactNode
}) {
  const { t } = useTranslation('inbox')
  const { project } = useProject()
  if (project.features.inbox) return <>{children}</>
  return (
    <div className="flex h-full flex-1 items-center justify-center p-10">
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <Inbox className="h-8 w-8 text-muted-foreground/60" />
        <h1 className="text-lg font-semibold">{t('disabled.title')}</h1>
        <p className="text-sm text-muted-foreground">{t('disabled.description')}</p>
        <Button asChild variant="outline" size="sm" className="mt-2">
          <Link to="/$projectId" params={{ projectId }}>
            {t('disabled.back')}
          </Link>
        </Button>
      </div>
    </div>
  )
}
